import { IDoorProxy } from 'models/contact_companies'
import { DataTypeColumn } from '../Common/commonColumnHelpers'
import { COMMON_COLUMNS } from '../Common/CommonColumnsInfo'

export const UNMATCHED_DOORS_COLUMNS = {
  name: {
    header: 'Name',
    group: 'Target Attributes',
    tooltipName: 'name',
  },
  domain: {
    header: 'Domain',
    group: 'Target Attributes',
    tooltipName: 'domain',
  },
  address: {
    header: 'Address',
    group: 'Target Attributes',
    tooltipName: 'address',
  },
  city: {
    header: 'City',
    group: 'Target Attributes',
    tooltipName: 'city',
  },
  state: {
    header: 'State',
    group: 'Target Attributes',
    tooltipName: 'state',
  },
  zipcode: {
    header: 'ZIP Code',
    group: 'Target Attributes',
    tooltipName: 'zipcode',
  },
  country: {
    header: 'Country',
    group: 'Target Attributes',
    tooltipName: 'country',
  },
  phone_number: {
    header: 'Phone Number',
    group: 'Target Attributes',
    tooltipName: 'phone_number',
  },
  extension: {
    header: 'Extension',
    group: 'Target Attributes',
    tooltipName: 'extension',
  },
  chain_size: {
    header: 'Chain Size',
    group: 'Target Attributes',
    tooltipName: 'chain_size',
  },

  // Account-related columns from COMMON_COLUMNS
  ...COMMON_COLUMNS,
} satisfies Partial<
  Record<keyof IDoorProxy | keyof typeof COMMON_COLUMNS, DataTypeColumn>
>
